export const DEALER_TYPES = ['dealer'];
export const ROOT = 'root';
export const ADMIN = 'admin';
export const DEALER = 'dealer';
export const AREA_MANAGER = 'area_manager';
export const GENERAL_MANAGER = 'general_manager';
export const LEADER = 'leader';
export const MANAGER_TYPES = ['area_manager', 'general_manager', 'leader'];
export const ADMIN_TYPES = ['root', 'admin'];
export const TICKET_TYPES = ['ssi', 'csi'];
export const TICKET_TYPE_CSI = 'csi';
export const TICKET_TYPE_SSI = 'ssi';
